import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../components/Navbar';
import { Mail, Phone, MapPin, MessageCircle, Send, CheckCircle, Loader2 } from 'lucide-react';

export default function Contato() {
  const [form,     setForm]     = useState({ nome:'', email:'', assunto:'', mensagem:'' });
  const [enviando, setEnviando] = useState(false);
  const [enviado,  setEnviado]  = useState(false);

  const enviar = async (e) => {
    e.preventDefault();
    setEnviando(true);
    // Simula envio (mailto ou integração futura)
    await new Promise(r => setTimeout(r, 1200));
    setEnviado(true);
    setEnviando(false);
  };

  return (
    <div className="min-h-screen bg-[#f9fafb]">
      <Navbar/>

      {/* Hero */}
      <section className="bg-gradient-to-br from-[#0a1f12] via-[#0f2318] to-[#1a3820] py-16 px-5 text-center">
        <div className="max-w-2xl mx-auto">
          <span className="inline-flex items-center gap-2 bg-acre-gold/15 text-acre-gold border border-acre-gold/25 text-xs font-bold px-4 py-1.5 rounded-full mb-4">
            📬 Fale Conosco
          </span>
          <h1 className="font-sora text-3xl md:text-4xl font-extrabold text-white mb-3">
            Entre em contato
          </h1>
          <p className="text-white/60 text-sm">
            Estamos aqui para ajudar. Responderemos em até 24h úteis.
          </p>
        </div>
      </section>

      <div className="max-w-5xl mx-auto px-5 py-12">
        <div className="grid md:grid-cols-2 gap-10">

          {/* Info */}
          <div>
            <h2 className="font-sora font-bold text-xl text-acre-dark mb-6">Informações de contato</h2>

            <div className="space-y-5">
              {[
                { icon: Mail,    cor:'bg-blue-50 text-blue-600',   titulo:'E-mail',    valor:'contato@acrejob.com.br',    href:'mailto:contato@acrejob.com.br' },
                { icon: MessageCircle, cor:'bg-green-50 text-green-600', titulo:'WhatsApp',  valor:'(11) 92538-2470',           href:'https://wa.me/5511925382470' },
                { icon: MapPin,  cor:'bg-red-50 text-red-500',     titulo:'Endereço',  valor:'Rio Branco, Acre — Brasil',  href:null },
              ].map(({ icon: Icon, cor, titulo, valor, href }) => (
                <div key={titulo} className="flex items-start gap-4">
                  <div className={`w-10 h-10 rounded-xl ${cor} flex items-center justify-center flex-shrink-0`}>
                    <Icon size={18}/>
                  </div>
                  <div>
                    <p className="text-xs text-gray-400 font-semibold uppercase tracking-wide">{titulo}</p>
                    {href
                      ? <a href={href} target="_blank" rel="noreferrer"
                          className="text-sm font-semibold text-acre-dark hover:text-acre-green transition-colors">{valor}</a>
                      : <p className="text-sm font-semibold text-acre-dark">{valor}</p>}
                  </div>
                </div>
              ))}
            </div>

            <div className="mt-8 bg-acre-light border border-acre-green/20 rounded-2xl p-5">
              <p className="font-sora font-bold text-acre-dark text-sm mb-2">🕐 Horário de atendimento</p>
              <p className="text-xs text-gray-600">Segunda a Sexta · 08h às 18h (horário de Brasília)</p>
              <p className="text-xs text-gray-400 mt-1">Sábado · 09h às 13h</p>
            </div>

            <div className="mt-5 bg-[#0f2318] rounded-2xl p-5 text-white">
              <p className="font-sora font-bold text-sm mb-2">🌿 AcreJob</p>
              <p className="text-white/60 text-xs leading-relaxed">
                Plataforma Nº1 de empregos do Acre, conectando candidatos e empresas
                com tecnologia de Inteligência Artificial.
              </p>
              <a href="https://acrejob.com.br" className="text-acre-gold text-xs hover:underline mt-2 inline-block">
                acrejob.com.br →
              </a>
            </div>
          </div>

          {/* Formulário */}
          <div className="card p-6">
            {enviado ? (
              <div className="text-center py-8">
                <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <CheckCircle size={32} className="text-green-500"/>
                </div>
                <h3 className="font-sora font-bold text-acre-dark text-lg mb-2">Mensagem enviada!</h3>
                <p className="text-gray-500 text-sm mb-5">
                  Obrigado por entrar em contato. Responderemos em breve no e-mail informado.
                </p>
                <button onClick={() => { setEnviado(false); setForm({ nome:'', email:'', assunto:'', mensagem:'' }); }}
                  className="btn-outline text-sm px-5 py-2.5">
                  Enviar outra mensagem
                </button>
              </div>
            ) : (
              <form onSubmit={enviar} className="space-y-4">
                <h3 className="font-sora font-bold text-acre-dark mb-1">Envie uma mensagem</h3>
                <div className="grid grid-cols-2 gap-4">
                  <div className="col-span-2">
                    <label className="label">Nome completo *</label>
                    <input className="input" required value={form.nome}
                      onChange={e => setForm(p=>({...p, nome:e.target.value}))}
                      placeholder="Seu nome"/>
                  </div>
                  <div className="col-span-2">
                    <label className="label">E-mail *</label>
                    <input className="input" type="email" required value={form.email}
                      onChange={e => setForm(p=>({...p, email:e.target.value}))}
                      placeholder="seu@email.com"/>
                  </div>
                  <div className="col-span-2">
                    <label className="label">Assunto *</label>
                    <select className="input" required value={form.assunto}
                      onChange={e => setForm(p=>({...p, assunto:e.target.value}))}>
                      <option value="">Selecione...</option>
                      <option>Dúvida sobre candidatos</option>
                      <option>Dúvida sobre vagas</option>
                      <option>Problemas técnicos</option>
                      <option>Planos e pagamentos</option>
                      <option>Parceria comercial</option>
                      <option>Outro</option>
                    </select>
                  </div>
                  <div className="col-span-2">
                    <label className="label">Mensagem *</label>
                    <textarea className="input min-h-28 resize-none" required value={form.mensagem}
                      onChange={e => setForm(p=>({...p, mensagem:e.target.value}))}
                      placeholder="Descreva sua dúvida ou mensagem..."/>
                  </div>
                </div>
                <button type="submit" disabled={enviando}
                  className="btn-primary w-full justify-center py-3 flex items-center gap-2 disabled:opacity-60">
                  {enviando
                    ? <><Loader2 size={15} className="animate-spin"/> Enviando...</>
                    : <><Send size={15}/> Enviar mensagem</>}
                </button>
              </form>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
